import React from "react";
export const ConfiguratorUpdateButton = ({ isDisable, onClickHandler }) => {
  let stylesCss = { fontSize: "18px", color: "gray", textDecoration: "none" };
  if (isDisable) {
    stylesCss = {
      fontSize: "18px",
      color: "gray",
      textDecoration: "none",
      cursor: "not-allowed",
    };
  }
  return (
    <a
      href=""
      className="icons_cls"
      title="Update"
      style={stylesCss}
      onClick={onClickHandler}
    >
      <i className="fa fa-check-square-o" aria-hidden="true"></i>
    </a>
  );
};
